export class DataTransferDirection {
    private _value: string

    public static readonly UPLOAD = "Upload"
    public static readonly DOWNLOAD = "Download"

    constructor(initialValue: string) {
        if (initialValue !== DataTransferDirection.UPLOAD && initialValue !== DataTransferDirection.DOWNLOAD) {
            throw new Error("Invalid initial value: " + initialValue)
        }
        this._value = initialValue
    }

    get value(): string {
        return this._value
    }

    set value(newValue: string) {
        if (newValue !== DataTransferDirection.UPLOAD && newValue !== DataTransferDirection.DOWNLOAD) {
            return
        }
        this._value = newValue
    }
}
